// crm-web/frontend/src/components/analytics/RangeSelector.jsx
// Dropdown para seleccionar rango temporal del dashboard.

import { VALID_RANGES, RANGE_LABELS } from '../../hooks/useAnalyticsRange'

export default function RangeSelector({ range, onChange }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-500 dark:text-gray-400">Rango:</span>
      <select
        value={range}
        onChange={(e) => onChange(e.target.value)}
        className="px-3 py-1.5 text-sm border border-gray-300 dark:border-gray-700
                   bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100
                   rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
      >
        {VALID_RANGES.map((r) => (
          <option key={r} value={r}>{RANGE_LABELS[r]}</option>
        ))}
      </select>
    </div>
  )
}
